import React, { Component } from 'react';

import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { AppContext } from './../AppContext';
import './css/NavMenu.css';
import logo from './img/svg/Logosistema.svg';
import url from "./variables/url.js";
import CasClient, { constant } from "react-cas-client";
import { ImExit } from 'react-icons/im';
import { FaRegUserCircle,FaHome } from 'react-icons/fa';

const CAS_PARAMS = url.cas.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color: color,
      backgroundColor: color,
      height: 2
    }}
  />
);

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  logout() {
    casClient.logout();
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const currentUser = this.context;
    return (
      <header>
        <Row>
                    <Col>
                        <img src={logo} style={{ width: "75%", height: "100%" }} />
                    </Col>
                    <Col>
                    {currentUser && currentUser.idpersona > 0 ?
                        <div className="name-Navbar icon-pointer" style={{ textAlign: 'right', position: 'relative', top: '50%', padding: '1vw' }}>{currentUser.apellidos} {currentUser.nombres} &nbsp; <FaRegUserCircle /></div>
                            :
                            ''
                    }                    
                    </Col>
                </Row>
        <ColoredLine color="#010453" />
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow" light style={{paddingTop:"0rem"}}>
          <Container fluid>
            
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                <NavLink tag={Link} className="text-dark" to="/"><FaHome title="Home" /></NavLink>
                </NavItem>
                <NavItem>
                  {currentUser && currentUser.usuario ?
                    <>
                      <NavLink tag={Link} className="user-login" onClick={this.logout}><ImExit height={"100px"} width={"1.5em"} title="Salir" /></NavLink></>
                    :
                    <NavLink tag={Link} className="user-login" to="/login" onClick={this.logout}>Usuario no autorizado</NavLink>
                  }
                </NavItem>
              </ul>
            </Collapse>
            
          </Container>
        </Navbar>
      </header>

    );
  }
}
NavMenu.contextType = AppContext;